import {Container} from '../components/Container'
import { Products } from '../components/Products'
import { SectionTitle } from '../components/SectionTitle'



// Translation
import { useTranslation } from "react-i18next";

import {dataFR} from "../assets/data/fr"
import {dataEN} from "../assets/data/en"
import {dataNL} from "../assets/data/nl"



const Manufacture = () => {

    const { i18n } = useTranslation();



    let data = dataFR;
    if (i18n.language === "fr") {
      data = dataFR;
    } else if (i18n.language === "en") {
      data = dataEN;
    } else if (i18n.language ==="nl"){
      data = dataNL;
    }
    
    return(
      
        <Container>
            <SectionTitle      
            preTitle={data.manufacture.preTitle}
            title={data.manufacture.title}
            />
            <Products data={data.blend}/>
            <Products imgPos="right" data={data.capsule}/>
            <Products data={data.tablet}/>
        </Container>
    )
}

export default Manufacture